// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__25rEc","bigColWidth":"Table_bigColWidth__3qHaV","biggerColWidth":"Table_biggerColWidth__2MYxT","row":"Table_row__2t5fA","col":"Table_col__2cZug"};